import { render, staticRenderFns } from "./EducationalJoiningApplications.vue?vue&type=template&id=6ba0aa62&"
import script from "./EducationalJoiningApplications.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports